// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1325":"715a7f40cdd53f460ef4","1760":"dd62e8aadc04c24216e7","6057":"b6bfbc3a4147ccbf6b52","7474":"04925fb2d1d2b9390985","8532":"88b90ac86f3060a3144e"}[chunkId] + ".css";
};